<div class="group" [ngClass]="detailClass">
	<ng-container *ngFor="let detail of tabDetails">
		<detail-section
			class="detail"
			[detailValue]="detail"
			[columns]="columns"
			[ngClass]="detailClass"
		>
		</detail-section>
	</ng-container>
</div>
